import { definitions } from 'generated/apiTypes'
import { AnyLayer } from '../types'
import { GeoJSONSourceSpecification } from 'maplibre-gl'
import { arabicToRoman } from '../utils'
import { featureCollection } from '@turf/turf'

export const DNLayersToMapData = (
  serverLayers: definitions['VectorBasemapResults'],
): { id: string; source: { [p: string]: GeoJSONSourceSpecification }; layer: AnyLayer }[] => {
  const returnValue: { id: string; source: { [p: string]: GeoJSONSourceSpecification }; layer: AnyLayer }[] = []
  let existingSource: { [p: string]: GeoJSONSourceSpecification } = {}
  if (serverLayers?.existing.length > 0) {
    serverLayers.existing.forEach((item, index) => {
      existingSource[`DN_${item.offset_type.diameter__mm}_${item.offset_type.class_}-source`] = {
        type: 'geojson',
        data: featureCollection([]),
      }
      returnValue.push({
        id: item.area_id,
        source: existingSource,
        layer: {
          id: `DN_${item.offset_type.diameter__mm}_${item.offset_type.class_}`,
          metadata: {
            name: `DN ${item.offset_type.diameter__mm} (${arabicToRoman(parseInt(item.offset_type.class_))})`,
          },
          type: 'fill',
          source: `DN_${item.offset_type.diameter__mm}_${item.offset_type.class_}-source`,
          minzoom: 0,
          maxzoom: 20,
          layout: {
            visibility: index === 0 ? 'visible' : 'none',
          },
          paint: {
            'fill-color': 'red',
            'fill-opacity': 31 / 255,
            'fill-outline-color': '#DD7474',
          },
        },
      })
      existingSource = {}
    })
  }
  return returnValue
}
